import {rootInstance} from './axiosConfig'; // Cambiar importación

const REFRESH_URL = 'refresh/';




/**
 * Función para renovar el access token.
 * Dado que los tokens se almacenan en cookies HttpOnly, el cliente no
 * puede acceder a ellos directamente; se confía en que el navegador envíe
 * las cookies automáticamente en cada solicitud.
 */
export const refreshAccessToken = async (): Promise<void> => {
    try {
        await rootInstance.post(REFRESH_URL); // Sin withCredentials (ya configurado)
    } catch (error: any) {
        
        throw new Error('Refresh token inválido');
    }
};
/**
 * Manejar sesión expirada redirigiendo o llamando al callback correspondiente.
 */




/**
 * Función auxiliar para realizar solicitudes autenticadas.
 * Se asume que el navegador enviará las cookies de sesión automáticamente.
 */
export const handleRequestWithAuth = async (
    requestFunc: () => Promise<any>
): Promise<any> => {
    try {
        return await requestFunc();
    } catch (error: any) {
        if (error.response?.status === 401) {
            await refreshAccessToken();
            return await requestFunc();
        }
        throw new Error(error.response?.data?.detail || 'Error en la solicitud');
    }
};

